import { Button } from '../ui/button';
import { Checkbox } from '../ui/checkbox';
import { Label } from '../ui/label';
import { Popover, PopoverContent, PopoverTrigger } from '../ui/popover';
import { Columns, GripVertical } from 'lucide-react';
import { ALL_COLUMNS } from './companiesHelpers';

/** Right-aligned "Columns" popover with All / Reset shortcuts, drag-to-reorder
 *  active columns, and a flat list of inactive columns at the bottom. */
export default function ColumnsPopover({
  columnOrder, setColumnOrder, dragIdx, onDragStart, onDragOver, onDragEnd, onToggleColumn,
}) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button variant="outline" className="gap-2" data-testid="companies-columns-btn">
          <Columns className="w-4 h-4" />
          Columns
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-64 p-3" align="end">
        <div className="flex items-center justify-between mb-3">
          <h4 className="font-semibold text-sm">Select Columns</h4>
          <div className="flex gap-2">
            <button className="text-xs text-blue-500 hover:underline" onClick={() => setColumnOrder(ALL_COLUMNS.map((c) => c.id))}>
              All
            </button>
            <button className="text-xs text-blue-500 hover:underline" onClick={() => setColumnOrder(ALL_COLUMNS.filter((c) => c.default).map((c) => c.id))}>
              Reset
            </button>
          </div>
        </div>
        <p className="text-xs text-gray-400 mb-2">Drag to reorder</p>
        <div className="space-y-1 max-h-72 overflow-y-auto">
          {columnOrder.map((colId, idx) => {
            const col = ALL_COLUMNS.find((c) => c.id === colId);
            if (!col) return null;
            return (
              <div
                key={col.id}
                draggable
                onDragStart={() => onDragStart(idx)}
                onDragOver={(e) => onDragOver(e, idx)}
                onDragEnd={onDragEnd}
                className={`flex items-center gap-2 px-1 py-1 rounded cursor-grab active:cursor-grabbing ${
                  dragIdx === idx ? 'bg-blue-50' : 'hover:bg-gray-50'
                }`}
              >
                <GripVertical className="w-3 h-3 text-gray-300 flex-shrink-0" />
                <Checkbox
                  id={`ccol-${col.id}`}
                  checked={true}
                  onCheckedChange={() => onToggleColumn(col.id)}
                  className="w-4 h-4"
                />
                <Label htmlFor={`ccol-${col.id}`} className="text-sm cursor-pointer flex-1">{col.label}</Label>
              </div>
            );
          })}
          {ALL_COLUMNS.filter((c) => !columnOrder.includes(c.id)).map((col) => (
            <div key={col.id} className="flex items-center gap-2 px-1 py-1 hover:bg-gray-50 rounded">
              <div className="w-3" />
              <Checkbox
                id={`ccol-${col.id}`}
                checked={false}
                onCheckedChange={() => onToggleColumn(col.id)}
                className="w-4 h-4"
              />
              <Label htmlFor={`ccol-${col.id}`} className="text-sm cursor-pointer flex-1 text-gray-400">{col.label}</Label>
            </div>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
}
